const ChatbotAnchorTag = ({ children, ...props }) => {
  const isReferenceLink = typeof children === 'string' && /^\d$/.test(children);
  const title = isReferenceLink ? 'View in docs' : null;

  return (
    <a target="_blank" rel="noopener noreferrer" {...props} className={isReferenceLink ? 'reference' : ''} data-title={title}>
      {children}
    </a>
  );
};

export default ChatbotAnchorTag;
